import { COMMON_COLUMNS, type DrilldownColumn } from '../drilldown-columns-shared';

/**
 * Columns for the "Won deals" tile drill-down (owner 2026-10-28).
 *
 * One row per DEAL that reached a won stage in the window. The tile figure is
 * a COUNT, so the row count reconciles to it; the value columns are reference.
 * Deals carry no document number, so the record link sits on the deal name
 * (`COMMON_COLUMNS.title` links when `number` is null). `date` is the window
 * date the backend counted the deal on.
 */

const dealName: DrilldownColumn = { ...COMMON_COLUMNS.title, label: 'Deal' };

const wonOn: DrilldownColumn = { ...COMMON_COLUMNS.date, label: 'Closing date' };

/** `stage` is the deal's stage name; display only, never branch on it. */
const stage: DrilldownColumn = {
  key: 'stage',
  label: 'Stage',
  get: (row) => row.stage ?? row.status,
  filter: 'options',
};

const dealValue: DrilldownColumn = { ...COMMON_COLUMNS.amount, label: 'Deal value' };

export const WON_DEALS_COLUMNS: DrilldownColumn[] = [
  dealName,
  COMMON_COLUMNS.company,
  COMMON_COLUMNS.projects,
  COMMON_COLUMNS.accountLead,
  wonOn,
  stage,
  COMMON_COLUMNS.billingRegion,
  COMMON_COLUMNS.currency,
  dealValue,
  COMMON_COLUMNS.convertedAmount,
];
